module.exports = __webpack_public_path__ + "static/media/welcome-challenges.576c6fed.png";